import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignJourneyHandoff } from '@/pages/workspaces/automations/[campaignId]/journeys/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/journeys/$subjectId',
)({
  component: JourneysCampaignJourneyHandoff,
});
